<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>
                        Term Result Sheet
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined
                        @change="getassschemedetails(); getStd()" hint="Please select academic year"
                        @click="putnull()" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" label="Semester" hint="Please select semester"
                        @click="putnull()" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="asd"
                        :items="assessment_detail_list" item-text="assessmenttype" item-value="id" return-object
                        label="Assessment Type" hint="Please select Assessment Type" @click="show = false" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv();"
                        hint="Please select standard" @click="putnull()" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined hint="Please select division"
                        @click="putnull()" />
                </v-col>
                <v-col sm="2" class="mt-6">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                        item-text="name" item-value="id" label="Status" outlined hint="Select Status" />
                </v-col>
                <v-col cols="12" sm="1" md="1" v-if="sel_ay_data && sel_std_data && div">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <span v-if="learner_course_list != null">
                <span v-if="show">
                    <v-row justify="end" class="mt-3">
                        <v-col cols="auto">
                            <v-btn class="no-display" rounded color="success" outlined @click="ExportToExcel()">
                                <v-icon color="success" left>mdi-export</v-icon>
                                Export
                            </v-btn>
                        </v-col>

                        <v-col cols="auto" class="mr-5">
                            <v-btn class="no-display" rounded color="warning" outlined @click="print()">
                                <v-icon color="warning" left>mdi-printer</v-icon>
                                Print
                            </v-btn>
                        </v-col>
                    </v-row>

                    <div id="my-table-id">
                        <v-row>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.school_logo" class="print-logo" width="60%" alt="logo" />
                            </v-col>
                            <v-col cols="12" sm="8" md="8" align="center">
                                <h5 v-if="org_basic_data.trust_name">
                                    {{ org_basic_data.trust_name }}
                                </h5>
                                <h2 style="text-transform: uppercase;" v-if="org_basic_data.school_name">
                                    {{ org_basic_data.school_name }}</h2>
                                <h4 style="text-transform: uppercase;"> {{ assessment_type }} - {{ academicyear }} </h4>
                                <h4>RESULT SHEET</h4>
                                <h5>Class : {{ standard }} | Section : {{ division }} | Class Teacher : {{ inst_name }}</h5>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.trust_logo" class="print-logo" width="60%" alt="logo" />
                            </v-col>
                        </v-row>

                        <v-col cols="12" sm="12" md="12" v-if="learnermarksheet_list.length > 0">
                            <v-simple-table dense class="elevation-1 result-table">
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Name of the student</th>
                                        <th v-for="course in course_headers" :key="course.crs" class="text-center">
                                            {{ course.crs }}
                                        </th>
                                        <th>Total</th>
                                        <th>%age</th>
                                        <th>Rank</th>
                                        <th>Remark</th>
                                    </tr>
                                    <tr>
                                        <th colspan="2" class="text-center">
                                            Marks Out Of
                                        </th>

                                        <th v-for="course in course_headers" :key="course.crs + '-sub'"
                                            class="text-center">
                                            {{ course.sub_marks }}
                                        </th>
                                        <th>{{ totalmarks }}</th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(student, sIndex) in learnermarksheet_list" :key="sIndex">
                                        <td class="text-center">
                                            {{ sIndex + 1 }}
                                        </td>
                                        <td>
                                            {{ student.name }}
                                        </td>
                                        <td v-for="course in course_headers" :key="course.crs" class="text-center"
                                            :class="{
                                                'fail-bg':
                                                    Object.values(student.leraner_marksheet)
                                                        .flat()
                                                        .find(m => m.crs === course.crs).isFail
                                            }">

                                            {{
                                                Object.values(student.leraner_marksheet)
                                                    .flat()
                                                    .find(m => m.crs === course.crs).marks
                                            }}

                                        </td>

                                        <td class="text-center font-weight-bold">
                                            {{ student.obtained_marks }}
                                        </td>

                                        <td class="text-center">
                                            {{ student.percentage }}
                                        </td>
                                        <td class="text-center">
                                            <span v-if="student.configuration_rank === 'True'">
                                                {{ student.rank }}
                                            </span>
                                            <span v-else>-</span>
                                        </td>
                                        <td :class="student.result !== 'Pass' ? 'red--text font-weight-bold' : ''"
                                            class="text-center font-weight-bold">
                                            {{ student.result }}
                                        </td>
                                    </tr>
                                    <tr class="font-weight-bold">
                                        <td colspan="2" class="text-center">
                                            Total Failures
                                        </td>

                                        <td v-for="count in subject_fail_count" :key="count + '-fail'"
                                            class="text-center red--text">
                                            {{ count }}
                                        </td>

                                        <td colspan="4"></td>
                                    </tr>

                                </tbody>
                            </v-simple-table>
                        </v-col>
                        <v-row class="mt-4 justify-space-between" dense
                            v-if="learnermarksheet_list.length > 0 && course_headers.length > 0">
                            <v-col cols="12" sm="4" md="5" class="ml-6">
                                <h4 class="mb-3 text-center">TOPPERS</h4>

                                <v-simple-table dense class="toppers-table"
                                    style="border-radius: 10px; overflow: hidden;">
                                    <thead style="background-color: #e3d5ca;">
                                        <tr>
                                            <th class="text-center">Rank</th>
                                            <th class="text-left">Name</th>
                                            <th class="text-center">Marks Obtained</th>
                                            <th class="text-center">%age</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="topper in learnermarksheet_list
                                            .filter(s => s.rank && ['1', '2', '3','4','5'].includes(s.rank.toString()))
                                            .sort((a, b) => parseInt(a.rank) - parseInt(b.rank))" :key="topper.name"
                                            :style="{
                                                backgroundColor:
                                                    parseInt(topper.rank) === 1 ? '#fff3e0' :
                                                        parseInt(topper.rank) === 2 ? '#e0f7fa' :
                                                            '#f3e5f5'
                                            }">
                                            <td class="text-center pa-1 font-weight-bold">{{ topper.rank }}</td>
                                            <td>{{ topper.name }}</td>
                                            <td class="text-center font-weight-medium">{{ topper.obtained_marks }}</td>
                                            <td class="text-center">{{ topper.percentage }}%</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>

                            <v-col cols="12" sm="3" md="2" class="text-center d-flex flex-column justify-end">
                                <div class="signature-box">
                                    <h4>Class Teacher</h4>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="3" md="2" class="text-center d-flex flex-column justify-end" 
                            v-if="show_checked_by_field==true">
                                <div class="signature-box">
                                    <h4>Crossed Checked by</h4>
                                </div>
                            </v-col>

                            <v-col cols="12" sm="3" md="2" class="text-center d-flex flex-column justify-end mr-5">
                                <div class="signature-box">
                                    <h4>Principal</h4>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </span>
            </span>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            snackbar: false,
            course_list: [],
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            asd: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            semester_list: null,
            sem: null,
            sem1: null,
            fetch_loader: false,
            assessment_detail_list: [],
            standard: null,
            division: "",
            academicyear: null,
            ass_detail_list: null,
            show: false,
            ass_detail_size: null,
            course_avg_list: [],
            learner_course_list: [],
            assessment_type: null,
            inst_name: null,
            totalmarks: 0,
            org_basic_data: [],
            subject_fail_count: [],
            learnermarksheet_list: [],
            show_checked_by_field:false,
            status_list: [
                { name: "Active", id: "0" },
                { name: "Temporary Inactive", id: "1" },
                { name: "Permanent Inactive", id: "2" },
            ],
            status: "0",
        };
    },
    methods: {
        putnull() {
            this.learner_course_list = []
            this.course_list = []
        },
        ExportToExcel() {
            const htmltable = document.getElementById('my-table-id');
            const html = htmltable.outerHTML;
            const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Term Result Sheet.xls';
            a.click();
            URL.revokeObjectURL(url);
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        getassschemedetails() {
            const data = {
                ay: this.sel_ay_data.ay_id,
            };
            axios
                .post("/WWSExamination/getassschemedetailsconfig", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.assessment_detail_list = res.data.assessment_detail_list;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.msg_flag);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        getreport() {
            if (!this.sel_ay_data || !this.sem || !this.asd || !this.sel_std_data || !this.div) {
                this.showSnackbar("error", "Please select all required fields!");
                return;
            }
            const data = {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                sem: this.sem,
                assessmentType: this.asd.id,
                div: this.div.div_off_id,
                status: this.status,
            };
            this.fetch_loader = true;
            this.learnermarksheet_list = [];
            axios
                .post("/SanjivaniExamination/generateTermResultSheet", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.standard = res.data.standard
                        this.division = res.data.div
                        this.academicyear = res.data.ay
                        this.learnermarksheet_list = res.data.learnermarksheet_list
                        this.inst_name = res.data.inst_name
                        this.org_basic_data = res.data.org_basic_data
                        this.sem1 = res.data.sem
                        this.assessment_type = res.data.assessment_type;
                        this.totalmarks = res.data.totalmarks;
                        this.subject_fail_count = res.data.subject_fail_count;
                        this.show_checked_by_field = res.data.show_checked_by_field;


                        let headersMap = new Map();

                        this.learnermarksheet_list.forEach(item => {
                            Object.values(item.leraner_marksheet).forEach(courseArr => {
                                courseArr.forEach(course => {
                                    if (!headersMap.has(course.crs)) {
                                        headersMap.set(course.crs, {
                                            crs: course.crs,
                                            sub_marks: course.sub_marks
                                        });
                                    }
                                });
                            });
                        });

                        this.course_headers = Array.from(headersMap.values());

                        this.fetch_loader = false
                        this.show = true
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.fetch_loader = false
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    this.fetch_loader = false
                })
                .finally(() => {
                    this.fetch_loader = false
                });
        },
        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },
        getDiv() {
            this.div_list = this.sel_std_data.div_list;
            this.div = this.div_list[0];
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.semester_list = res.data.sem_list
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => { });
        },

    },
    mounted() {
        this.onload();
        
    },
};
</script>
<style scoped>
.result-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.result-table th {
    border: 0.5px solid #fff;
    padding: 6px 8px;
    vertical-align: middle;
}

.result-table td {
    border: 0.6px solid #b5b4b4;
    padding: 6px 8px;
    vertical-align: middle;
}

.result-table thead th {
    background-color: #0d3789;
    color: white !important;
    font-weight: 600;
    text-align: center;
    white-space: nowrap;
}

.result-table thead tr:nth-child(2) th {
    font-size: 12px;
    background-color: #0d3789;
    color: white !important;
}

.result-table tbody td:nth-child(2) {
    text-align: left;
    font-weight: 500;
}

.result-table tbody td:not(:nth-child(2)) {
    text-align: center;
}

.result-table tbody tr:hover {
    background-color: #f9fafb;
}

.fail-bg {
    background-color: #ffebee;
    /* color: red;             */
    font-weight: 600;
}

.signature-box {
    border-top: 1px solid #444;
    padding-top: 6px;
    margin-top: 40px;
    font-size: 14px;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

@media print {
    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    @page {
        margin-top: -60px !important;
        padding: 0;
        margin: 0;
        size: 18in 27in;
    }
    .box{
        border: none !important;
    }

    .result-table th,
    .result-table td {
        border: 1px solid #000;
        font-size: 18px !important;
    }

    .toppers-table th, 
    .toppers-table td 
    {
        font-size: 18px !important;
    }

    h5 {
        font-size: 20px;
        font-weight: bold;
    }

    h2 {
        font-size: 40px;
        font-weight: bold;
    }

    h4 {
        font-size: 25px;
        font-weight: bold;
    }
}
</style>
